import DateTimeUtil from "./DateTimeUtil";

export const calcFilterData = (data, filterValue, filteredSettings, filterEnum) => {
    const filterArr = Array.isArray(filterValue)
    const valueIsObject = typeof filterValue === 'object' && filterValue !== null && !filterArr
    const settings = (filteredSettings || []).filter((it) => it && it.id)

    if (!settings.length) {
        return data
    }

    return !filterValue ? data : data.filter((el) => {
        if (!el) {
            return false
        }
        return settings.some((it) => {
            const value = it.field2
                ? el[it.id]?.[it.field]?.[it.field2]
                : it.field
                    ? el[it.id]?.[it.field]
                    : el[it.id]

            if (filterArr) {//  filterVariant: 'multi-select',
                if (filterValue.length === 0) return true
                if (it.filterFn) {
                    // exact: avoid substring matches ("21_век" must not match "21_век_Склад")
                    return filterValue.some((option) => it.filterFn(value, option, filterEnum, {exact: true}))
                }
                return filterValue.includes(value)
            }
            if (valueIsObject) {
                const before = DateTimeUtil.checkDateBefore(value, filterValue.startDate)
                const after = DateTimeUtil.checkDateAfter(value, filterValue.endDate)
                return (filterValue.startDate && filterValue.endDate) ? (before && after) : true
            }
            if (it.filterFn) {
                return it.filterFn(value, filterValue?.toLowerCase?.() ?? filterValue, filterEnum)
            }
            return value?.toString()?.toLowerCase()?.includes(filterValue?.toLowerCase?.() ?? filterValue)
        })
    })
}
